import { useLocation, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Router from "../../routes";
import { useAddDispatch, useAppSelector } from "../../store";
import { isLoggedIn, User } from "../../auth/userManager";
import { useEffect, useState } from "react";
import { UpdateLoginUserData } from "../../auth/userSlice";
import { getTopLevelMenus } from "../../utility/layoutTheme";
import { findTopModuleCodeForPath } from "../../utility/navMenuSearch";

function MainLayout(props: any) {
    const dispatch = useAddDispatch();
    const location = useLocation();
    const modulePermission = useAppSelector((state: any) => state.userSlice?.user?.modulePermission);
    const [parentCode, setParentCode] = useState<string | null>(null);
    const IsLoggedIn = isLoggedIn();
    const navigate = useNavigate();
    const handleNavFunc = async (redirectTo: any) => {
        navigate(redirectTo);
    };

    useEffect(() => {
        dispatch(UpdateLoginUserData(User()));
    }, [dispatch]);

    useEffect(() => {
        const topMenus = getTopLevelMenus(modulePermission);
        if (!topMenus.length) {
            setParentCode(null);
            return;
        }

        const codeForPath = findTopModuleCodeForPath(
            modulePermission,
            location.pathname,
            location.search
        );
        setParentCode(codeForPath ?? topMenus[0].code);
    }, [location.pathname, location.search, modulePermission]);

    useEffect(() => {
        const handleBeforeUnload = (e: any) => {
            e.preventDefault();
            e.returnValue = ''; // required for Chrome
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    
    return (
        <>
            {IsLoggedIn &&
                <Header
                    handleNavFunc={handleNavFunc}
                    parentCode={parentCode}
                    setParentCode={setParentCode}
                />
            }
            <div className="container-fluid page-body-wrapper">
                {IsLoggedIn &&
                    <Sidebar
                        handleNavFunc={handleNavFunc}
                        parentCode={parentCode}
                    />
                }
                <Router></Router>
            </div>
            {IsLoggedIn && <Footer />}
            {/* {IsLoggedIn && <Roe />} */}
        </>
    );
};

export default MainLayout